let pipelinesBaseUrl;
export function setPipelinesBaseUrl(baseUrl) {
    pipelinesBaseUrl = baseUrl;
}
export function getPipelinesBaseUrl() {
    return pipelinesBaseUrl;
}
//# sourceMappingURL=pipelines-base-url.js.map